<div class="filters-box">
  <div class="filters">
    <div>
      <app-select [options]="sortColumnOptions"
                  [small]="true"
                  [(ngModel)]="sortColumn"
                  (ngModelChange)="filter()"
      ></app-select>
    </div>
    <div>
      <app-select [options]="sortDirectionOptions"
                  [small]="true"
                  [(ngModel)]="sortDirection"
                  (ngModelChange)="filter()"></app-select>
    </div>
    <div class="form form-no-width">
      <input [(ngModel)]="search"
             (ngModelChange)="filter()"
             class="small-input"
             placeholder="zoek..."
             type="text">
    </div>
  </div>
  <div class="pagination">
    <mat-paginator #paginator
                   (page)="pageEvent = getTransactions($event)"
                   [length]="length"
                   [pageSize]="this.pageSize"
                   hidePageSize="true">
    </mat-paginator>
  </div>
</div>
<div class="clearFix"></div>
<div class="clearFix"></div>

<div *ngFor="let transaction of transactions">
  <div *ngIf="!transaction.hidden"
       [@items]
       class="overflow-hidden">
    <div [ngClass]="transaction.debitCredit" class="transaction assigned">
      <div class="transaction-amount center">
        <div class="value">
          {{transaction.debitCredit == 'C' ? '+' : '-'}}
          {{currencyService.symbol(transaction.currency)}}{{currencyService.format(transaction.amount)}}
        </div>
        <div class="date">{{transaction.valueDate}}</div>
      </div>
      <div class="transaction-details">
        <div class="flex">
          <div class="col-4">
            <div class="header">IBAN</div>
            {{transaction.iban ? transaction.iban : '-'}}
          </div>
          <div class="col-4">
            <div class="header" *ngIf="transaction.subcategory.category !== ''">categorie</div>
            {{transaction.subcategory.category}}
          </div>
          <div class="col-4">
            <div class="header">
              subcategorie
            </div>
            {{transaction.subcategory.name}}
            <mat-icon *ngIf="!isLeefgeldRekening" (click)="withdrawAssignment(transaction)" class="pointer icon-hover remove-subcategory-button">
              undo
            </mat-icon>
          </div>
        </div>
        <div class="flex">
          <div class="pt14 pr12">
            <div class="header">
              omschrijving
            </div>
            {{transaction.transactionDescription}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
